/**
 * External dependencies
 */
import { BlogPostsIcon } from '~cartzillagb/icons'
import { range } from '~cartzillagb/util'
import {
	disabledBlocks, i18n, srcUrl
} from 'cartzillagb'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'
import DefaultImage  from  './img/img1.png'


/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks'
import { __ } from '@wordpress/i18n'


export const schema = {
	className : {
		type: 'string',
	},
	enableContainer: {
		type: 'boolean',
		default: true,
	},
	limit: {
		type: 'number',
		default: 3,
	},
	listlimit: {
		type: 'number',
		default: 3,
	},
	lgColumns : {
		type: 'number',
		default: 3,
	},
	smColumns : {
		type: 'number',
		default: 2,
	},
	heading : {
		type: 'string',
	},
}

const maxLimit = applyFilters( 'cartzillagb.outlet-store.edit.inspector.max.limit', 12 )

{ range( 1, maxLimit + 1 ).forEach( i => {

	schema[ `mediaURL${ i }` ] = {
		type: 'string',
		default: `${ srcUrl }/${ DefaultImage }`
	}
	schema[ `name${ i }` ] = {
		type: 'string',
		
	}
	const MaxListlimit = applyFilters( 'cartzillagb.outlet-store.edit.inspector.max.listimit', 6 )

	{ range( 1, MaxListlimit + 1 ).map( j => {
		schema[ `iconname${ i }${ j }` ] = {
			type: 'string',
		}
		schema[ `icon${ i }${ j }` ] = {
			type: 'string',
		}
		schema[ `icondesc${ i }${ j }` ] = {
			type: 'string',
		}
		schema[ `iconlink${ i }${ j }` ] = {
			type: 'string',
			default: '#'
		}
		return ""
	} ) }
} ) }



export const name = 'czgb/outlet-store'

export const settings = {
	title: __( 'Stores', i18n ),
	description: __( 'Allows you to list information about your outlets in the Contact Page', i18n ),
	icon: BlogPostsIcon,
	category: 'cartzillagb',
	example: {},
	keywords: [
		__( 'outlet-store', i18n ),
		__( 'CartzillaGb', i18n ),
	],
	attributes: schema,
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,

	// CartzillaGB modules.
	modules: {
		'advanced-responsive': true,
	},
}